import { get } from 'lodash';
import { LC_CONTENT_CDN } from '../constants/passage';
import { SET_LC_CONTENT } from './lcActions';

export const defaultState = {
    id: undefined,
    title: undefined,
    comprehensionItems: [[], []],
    content: [{}, {}],
};

const getFullContentPath = path => {
    let lcCDNUrl = LC_CONTENT_CDN;
    if (process.env.NODE_ENV !== 'development' && get(window, 'amplify_lantern_config.lcCDNUrl'))
        lcCDNUrl = window.amplify_lantern_config.lcCDNUrl;

    return lcCDNUrl.concat(path);
};

/**
 * Change passage comprehension questions item from backend to frontend format
 * @example formatComprehensionItems([[{
 *     item_index: 0,
 *     responses: [
 *         { response_index: 0, is_correct: false, response_transcript: 'Amy', audio_path: 'fake/path.mp3' },
 *         { response_index: 1, is_correct: false, response_transcript: 'Barry', audio_path: 'fake/path.mp3' },
 *         { response_index: 2, is_correct: true, response_transcript: 'David', audio_path: 'fake/path.mp3' },
 *     ],
 *     question_transcript: 'Who was the main character of the story?',
 *     question_audio_path: 'fake/question/path.mp3'
 * }]],
 * }]) => [[{
 *     id: 0,
 *     possibleResponses: [
 *         { id: 0, audio: 'fake/path.mp3', text: 'Amy' },
 *         { id: 1, audio: 'fake/path.mp3', text: 'Barry' },
 *         { id: 2, audio: 'fake/path.mp3', text: 'Clara' },
 *         { id: 3, audio: 'fake/path.mp3', text: 'David' },
 *     ],
 *     stimulus: {
 *         text: 'Who was the main character of the story?',
 *         audio: 'fake/question/path.mp3'
 *     },
 * }]]
 */
const formatComprehensionItems = comprehensionItems =>
    comprehensionItems.map(comprehensionItemList =>
        comprehensionItemList.map(comprehensionItem => ({
            id: comprehensionItem.item_index,
            possibleResponses: comprehensionItem.responses.map(response => ({
                id: response.response_index,
                audio: getFullContentPath(response.audio_path),
                text: response.response_transcript,
            })),
            stimulus: {
                text: comprehensionItem.question_transcript,
                audio: getFullContentPath(comprehensionItem.question_audio_path),
            },
        })),
    );

const formatContent = content =>
    Object.keys(content).map(passageSectionKey => ({
        image: getFullContentPath(content[passageSectionKey].image_path),
        audio: getFullContentPath(content[passageSectionKey].audio_path),
    }));

const passageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_LC_CONTENT:
            return {
                ...state,
                id: action.content.passage_id,
                title: action.content.title,
                comprehensionItems: formatComprehensionItems(action.content.comprehension_items),
                content: formatContent(action.content.content),
            };
        default:
            return state;
    }
};

export default passageReducer;
